import { createFileRoute } from "@tanstack/react-router";
import TailwindBuilderPage from "@/pages/TailwindBuilderPage";

export const Route = createFileRoute("/tools/tailwind-builder")({
  component: TailwindBuilderPage,
});
